import { Box, Paper, Stack, Tooltip, Typography } from '@mui/material';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { formatMetric, metricValue } from './metrics';

/**
 * A KPI: the value for the range and its change against the previous period. The change stays in text colours:
 * more spend or impressions is not good or bad on its own.
 */
export default function StatTile({ metric, totals, previous, currency, previousLabel }) {
  const value = metricValue(totals, metric);
  const before = metricValue(previous, metric);
  const change = value != null && before ? (value - before) / before : null;
  const Icon = change == null || Math.abs(change) < 0.005 ? TrendingFlatIcon
    : change > 0 ? TrendingUpIcon : TrendingDownIcon;

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3, minWidth: 0 }}>
      <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>{metric.label}</Typography>
      <Typography sx={{ fontSize: 26, fontWeight: 600, lineHeight: 1.3, mt: 0.5, color: 'text.primary' }} noWrap>
        {formatMetric(value, metric, currency)}
      </Typography>
      <Tooltip title={`${previousLabel}: ${formatMetric(before, metric, currency)}`}>
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.5, color: 'text.secondary' }}>
          <Icon sx={{ fontSize: 18 }} />
          <Typography variant="caption" sx={{ fontSize: 12.5 }} noWrap>
            {change == null ? 'No earlier data' : (
              <>
                <Box component="span" sx={{ fontWeight: 600, color: 'text.primary' }}>
                  {`${change > 0 ? '+' : ''}${(change * 100).toFixed(1)}%`}
                </Box>
                {' vs previous period'}
              </>
            )}
          </Typography>
        </Stack>
      </Tooltip>
    </Paper>
  );
}
